/** Globale_fase answer_options order from characteristics_schema.tsx */
export const PAGER_PHASE_ORDER = [
    'Alarmering',
    'Uitruk',
    'Verkenning',
    'Inzet',
    'Nazorg',
    'Inruk',
] as const;

export type PagerPhase = (typeof PAGER_PHASE_ORDER)[number];

export function parseGlobaleFase(
    answer: string | string[] | null | undefined,
): string[] {
    if (answer == null) return [];
    const raw = Array.isArray(answer) ? answer : [answer];
    return raw
        .map((v) => String(v).trim())
        .filter((v) => v.length > 0);
}

/** Index of the most advanced selected phase; null when none match. */
export function getPagerPhaseIndex(
    answers: string[],
): number | null {
    if (answers.length === 0) return null;
    let maxIdx = -1;
    for (const a of answers) {
        const idx = PAGER_PHASE_ORDER.findIndex(
            (p) => p.toLowerCase() === a.toLowerCase(),
        );
        if (idx > maxIdx) maxIdx = idx;
    }
    return maxIdx >= 0 ? maxIdx : null;
}
